<template>
  <div>
    <x-table
      ref="list"
      listApi="biz.warehouse.vet.receipt.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无兽药出入库上传记录信息"
      :fieldList="fieldList"
      :defaultParams="defaultParams"
      :actionWidth="80"
    >
    </x-table>
    <div style="margin-top: 20px">
      <span style="color: #919191"> * 请按月导出完整的数据，并打印留档保存 </span>
    </div>
  </div>
</template>

<script>
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";

export default {
  components: {
    customerStoreSelect,
  },
  props: {
    params: {
      type: Object,
    },
  },
  data() {
    return {
      fieldList: [
        {
          label: "日期",
          width: "100",
          fixed: "left",
          render: (row) => new Date(row.createTime).format("YYYY/MM/dd"),
        },
        {
          label: "商品名称",
          className: "oneline",
          width: "160",
          render: (row) => row.drugName || "-",
        },
        {
          label: "通用名称",
          className: "oneline",
          minWidth: "180",
          render: (row) => row.genericName || "-",
        },
        {
          label: "批准文号",
          className: "oneline",
          width: "200",
          render: (row) => row.approvalNum || "-",
        },
        {
          label: "生产批次",
          className: "oneline",
          width: "150",
          render: (row) => row.batchCode || "-",
        },
        {
          label: "药品规格",
          className: "oneline",
          width: "150",
          render: (row) => row.drugSpec || "-",
        },
        {
          label: "药品剂型",
          className: "oneline",
          width: "150",
          render: (row) => row.drugDosage || "-",
        },
        {
          label: "有效日期",
          width: "120",
          render: (row) => row.validDate || "-",
        },
        {
          label: "购货单位",
          width: "120",
          className: "oneline",
          show: () => this.defaultParams.receiptType == "order_sale",
          render: (row) => row.memberName || "-",
        },
        {
          label: "数量",
          width: "80",
          fixed: "right",
          render: (row) => row.receiptCount || "-",
        },
        {
          label: "经手人员",
          width: "120",
          fixed: "right",
          render: (row) => row.handledBy || "-",
        },
      ],
    };
  },
  computed: {
    defaultParams() {
      return Object.assign({}, this.params || {});
    },
  },
};
</script>
